<template>
	
	<div class="page page-3" style="padding-bottom:0.5rem">
		
		<van-nav-bar title="首页" fixed placeholder @click-right="onClickRight" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false">
			<template #right>
				<div id="xxx">
					<van-icon name="weapp-nav" :dot="!feedbook_click" color="#323233" size="18" />
				</div>
			</template>
		</van-nav-bar>
		
		<van-notice-bar v-if="this.$Setting.notice" color="#1989fa" background="#ecf9ff" left-icon="info-o">{{this.$Setting.notice}}</van-notice-bar>
		
		<div class="s1">
			<div class="b1">
				<div class="p1">
					{{this.$Setting.web_title}}
				</div>
			</div>
		</div>
		<div class="s2" v-if="list.length">
			<div class="b1">
				<b>
					套餐版本
				</b>
			</div>
			<div class="b2" style="flex-wrap: wrap;">
				<div class="item" v-for="(item, index) in list" :key="item.id" :style="{marginBottom: '0.15rem'}">
					<div class="wrap" :class="select_index==index?'active':''" @click="selectProduct(index)">
						<div class="p1">
							{{item.title}}<small>/{{item.day}}天</small>
						</div>
						<div class="p2">
							<small>￥</small>{{item.price}}
						</div>
						<div class="p3">
							{{item.des}}
						</div>
					</div>
				</div>

			</div>

			
			<van-cell title="兑换码" value="使用" is-link to="/codes-center">
				<template #icon>
					<van-icon name="send-gift-o" color="#1989fa" class="c-left-icon" />
				</template>
			</van-cell>
			
			<div style="padding-bottom: 15px;width: 100%;text-align: center;background: #ffffff;margin-top:5px;">
				<a href="javascript:void(0)" style="display: block;height: 0.42rem;background: rgb(40, 140, 250);line-height: 0.42rem;width: 92%;margin: 0 auto;color: #fff;border-radius: 10px;font-size: 14px;"
				 @click="buyInfo">
					立即购买
				</a>
			</div>

		</div>

		<div class="s4">
			<div class="px-3 pt-3 pb-2">
				<b>
					{{this.$Setting.web_bot_name}}介绍
				</b>
			</div>
			<div class="px-3 pb-3">
				<div class="p-2 fs-12" style="line-height: 0.2rem; color: rgb(102, 102, 102); border-radius: 0.1rem;">
					<div class="flex">
						<img src="../../assets/icon-12.jpg" class="mr-1" style="height: 0.15rem; display: block;">
						{{this.$Setting.web_title}}-个人号版
					</div>
					<div class="mt-1">
						将您自己的个人号扫码登录到我们平台，平台给您的个人号赋能将其变成{{this.$Setting.web_bot_name}}，让它可以开通群中心，拥有智能娱乐群管等等超级好玩实用的功能。
					</div>
				</div>
			</div>
		</div>




		<div class="s3">
			<div class="p-3">
				<b>
					基础功能
				</b>
			</div>
			<div class="b3">
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-6-1.png">
					</div>
					<div class="p1">
						智能聊天
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-10-2.png">
					</div>
					<div class="p1">
						点歌
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-10-5.png">
					</div>
					<div class="p1">
						查天气
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-6-3.png">
					</div>
					<div class="p1">
						入群欢迎
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-6-4.png">
					</div>
					<div class="p1">
						退群提醒
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-6-6.png">
					</div>
					<div class="p1">
						数据统计
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-6-7.png">
					</div>
					<div class="p1">
						天气播报
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-6-8.png">
					</div>
					<div class="p1">
						群互动
					</div>
				</div>
			</div>
			<div class="p-3">
				<b>
					回复功能
				</b>
			</div>
			<div class="b3">
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-7-1.png">
					</div>
					<div class="p1">
						文字回复
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-7-2.png">
					</div>
					<div class="p1">
						图片回复
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-7-3.png">
					</div>
					<div class="p1">
						小程序回复
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-7-4.png">
					</div>
					<div class="p1">
						暗号进群
					</div>
				</div>
			</div>
			<div class="p-3">
				<b>
					护群功能
				</b>
			</div>
			<div class="b3">
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-8-1.png">
					</div>
					<div class="p1">
						黑名单管理
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-8-2.png">
					</div>
					<div class="p1">
						自动踢人
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-8-3.png">
					</div>
					<div class="p1">
						敏感信息警告
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-8-4.png">
					</div>
					<div class="p1">
						艾特[@]踢人
					</div>
				</div>
			</div>
			<div class="p-3">
				<b>
					娱乐功能
				</b>
			</div>
			<div class="b3">
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-10-1.png">
					</div>
					<div class="p1">
						猜图片
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-10-2.png">
					</div>
					<div class="p1">
						猜歌名
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-10-4.png">
					</div>
					<div class="p1">
						成语接龙
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-7-1.png">
					</div>
					<div class="p1">
						找茬
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-10-6.png">
					</div>
					<div class="p1">
						猜王者英雄
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-10-7.png">
					</div>
					<div class="p1">
						打劫
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-10-8.png">
					</div>
					<div class="p1">
						积分/金币
					</div>
				</div>
				<div class="item">
					<div class="icon">
						<img src="../../assets/icon-6-4.png">
					</div>
					<div class="p1">
						签到
					</div>
				</div>
			</div>
		</div>


		<van-popup v-if="list.length>0" v-model="show_buy_info" round position="bottom" :style="{ height: buy_info_height}">
			<div style="padding: 1em;">
				<div style="height: 2.2em;border-bottom: 1px solid #EBEDF0;margin-bottom: .5em;">
					<van-checkbox v-model="checked" :style="{float: 'left'}">我已阅读并同意</van-checkbox>
					<div style="color: #288CFA;display: inline;float: left;" @click="showArgeement">《购买协议》</div>
				</div>
				<div class="buy-info">
					<div class="info-0">
						<div class="info-0-title">购买版本：</div>
						<div>{{list[select_index].title}}</div>
					</div>
					<div class="info-0">
						<div class="info-0-title">服务群数：</div>
						<div>1</div>
					</div>
					<div class="info-0">
						<div class="info-0-title">支付方式：</div>
						<div>微信支付</div>
					</div>
				</div>
				<div style="margin-top: 1em;">
					<van-button type="primary" :disabled="!checked" color="#288CFA" block @click="confirmBuy">确认购买</van-button>
				</div>

			</div>
		</van-popup>
		<van-dialog v-if="list.length>0" v-model="show_argeement" title="购买协议">
			<div style="padding: 1em;font-size: 12px;">
				<p>1、本产品为{{list[select_index].title}}，开通后可使用{{list[select_index].day}}天。开通后将与群绑定。</p>
				<p>2、购买1个，可管理1个群，多个群管理需购买多个权限。</p>
				<p>3、本产品因特殊性，购买后不支持退款。如出现操作使用及其他问题，可前往微信公众号咨询客服。</p>
				<p>4、严禁利用本产品参与赌博、传销、色情等一切违法活动以及散布法律禁止的内容信息。一经发现，本公司有权无条件收回助手使用权。</p>
				<br>
				<p>友情提示：</p>
				<p>使用本产品前请严格遵守《腾讯微信软件许可及服务协议》，本产品仅为用户提供针对社群运营管理提供方便，无法完全避免频繁操作造成的强制掉线、封号等问题，请在使用过程中根据运营经验自行把控风险。</p>
			</div>
		</van-dialog>

		<van-share-sheet v-model="show_option" title="选择" :options="options" @select="onSelect" />
	</div>

</template>

<script>
	import Vue from 'vue';
	import {
		Popup,
		Checkbox,
		Button,
		NavBar,
		Cell,
		ShareSheet,
		NoticeBar,
		Icon
	} from 'vant';

	Vue.use(Icon);
	Vue.use(Popup);
	Vue.use(Checkbox);
	Vue.use(Button);
	Vue.use(ShareSheet);
	Vue.use(NavBar);
	Vue.use(Cell);
	Vue.use(NoticeBar);
	export default {
		data() {
			return {
				list: [],
				select_index: 0,
				price: 0,
				show_buy_info: false,
				show_argeement: false,
				checked: false,
				buy_info_height: window.innerHeight - 1000 + 'em',
				unused: 0,
				feedbook_click: false,
				show_option: false,
				options: [
					// { name: '在中APP打开', icon: require('@/assets/app.png'), id: 1 },
					{
						name: '投诉',
						icon: require('@/assets/tousu.png'),
						id: 2
					},
				],
				web_title: this.$Setting.web_title,
				web_bot_name: this.$Setting.web_bot_name,
                isLook: false
			}
		},
		mounted() {
			this.$ApiUtil.Buy.getProduct().then(res => {
				this.list = res.list, this.selectProduct(0)
			})
			this.unused = localStorage.getItem('unused') ? parseInt(localStorage.getItem('unused')) : 0
			this.feedbook_click = localStorage.getItem('feedbook_click') ? localStorage.getItem('feedbook_click') : false
            
            var channel_id = typeof this.$route.params.channel_id === 'undefined' ? 0 : this.$route.params.channel_id
            
            if(!localStorage.getItem('channel_id')) localStorage.setItem('channel_id', channel_id)
            
		},
		methods: {
			onSelect(e) {
				switch (e.id) {
					case 1:
						location.href = this.$Setting.app_scheme
						break;
					case 2:
						this.$router.push('/feedbook-center')
						break;
				}
			},
			onClickRight() {
				this.feedbook_click = true, localStorage.setItem('feedbook_click', true)

				this.show_option = !this.show_option
			},
			showArgeement() {
				this.show_argeement = true
                this.isLook = true
			},
			buyInfo() {
				this.show_buy_info = true
			},
			selectProduct(index) {
				this.select_index = index
				this.price = this.list[index].price
			},
			confirmBuy() {
				this.show_buy_info = false
				if (this.select_index < 0) {
					this.$toast.fail('请选择购买时长')
					return;
				}
                if(!this.isLook) {
                    this.$dialog.alert({
                    	message: '请您仔细阅读<b>《购买协议》</b>后再确认购买\n谢谢合作！'
                    }).then(() => {}).catch(()=>{})
                    return;
                }
				var product_id = this.list[this.select_index].id
				this.$ApiUtil.Order.createOrder({
					product_id: product_id
				}).then(res => {

					if (res.status == 0) {
						this.$toast.fail(res.message)
						return
					} else {

						if (typeof res.url !== 'undefined') {
							// location.href = res.url
							var url = encodeURIComponent(res.url)
							var order_sn = res.order_sn
							var str = JSON.stringify({
								url: url,
								sn: order_sn
							})
							this.$router.push(`/pay-${str}`)
						}
					}

					//this.weixinPay(res.pay_info)
				})

			},
			weixinPay(data) {
				if (typeof WeixinJSBridge == "undefined") { //微信浏览器内置对象。参考微信官方文档
					if (document.addEventListener) {
						document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(data), false);
					} else if (document.attachEvent) {
						document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(data));
						document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(data));
					}
				} else {
					this.onBridgeReady(data);
				}
			},
			onBridgeReady(data) {
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest', JSON.parse(data),
					res => {
						if (res.err_msg == "get_brand_wcpay_request:ok") {
							this.$router.push('/member-center')
						}
					}
				);
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/style.css");
	@import url("../../assets/buy-intro-v4.css");

	.buy-info {
		display: flex;
		flex-direction: column;
	}

	.info-0 {
		display: flex;
		justify-content: space-between;
		margin: .5em;
		font-size: 12px;
	}

	.info-0 div {
		color: #288CFA;
	}

	.info-0 .info-0-title {
		color: #000000;
		font-weight: bold;
	}

	.fs-12 {
		background: url(../../assets/icon-11.png) center center / cover;
	}
	
	.c-left-icon{
		line-height: inherit;
		font-size: 16px;
		margin-right: 4px;
	}
	.van-cell{
		margin: 0 auto;
		width: 90%;
		background: rgba(40, 140, 250, 0.08);
		border-radius: 10px;
		margin-bottom: 10px;
		color: #717171;
	}
</style>
